// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"35e6584065fa419ecdbe","522":"eb56bf65d8e90add797d"}[chunkId] + ".js";
};